import { useContext, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { useAuth0 } from '@auth0/auth0-react';

import ListItem from 'components/ListItem';
import PhoneListItem from 'components/PhoneListItem';
import SignInButton from 'components/SignInButton';
import UserProfile from 'components/UserProfile';

import purlAgentContext from 'contexts/purlAgentContext';

import handleEvent from 'utilities/handleEvent';
import {
    PURL_AGENT_CODE,
    PURL_AGENT_CODE_NEW,
    PURL_AGENT_DATA
} from 'utilities/sessionStorageKeys';
import { LEAD_ID_KEY } from 'utilities/storageKeys';
import toBoolean from 'utilities/toBoolean';

import styles from './styles.module.scss';

import { remove } from 'temp/utilities/storage';

const HamburgerMenu = ({ className = '', isOpen, items, onItemClick }) => {
    const history = useHistory();
    const { isAuthenticated, loginWithRedirect, logout } = useAuth0();

    const [activedLink, setActivedLink] = useState('');

    const { purlAgentData } = useContext(purlAgentContext);

    useEffect(() => {
        history?.location?.pathname !== activedLink &&
            setActivedLink(history.location.pathname);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [history.location.pathname]);

    const isHomePage = window.location.pathname === '/';

    const handleNavigation = url =>
        handleEvent(onItemClick, () => {
            history.push(url);
        });

    const handleLogout = async () => {
        remove(LEAD_ID_KEY);
        remove(PURL_AGENT_CODE_NEW);
        remove(PURL_AGENT_CODE);
        remove(PURL_AGENT_DATA);
        logout({ logoutParams: { returnTo: window.location.origin } });
    };

    const handleLoginClick = async () => {
        try {
            await loginWithRedirect();
        } catch (e) {
            console.error('sign in error: ', e);
        }
    };

    return (
        <ul
            className={`${styles.hamburgerMenu} ${className} ${
                isOpen ? styles.open : ''
            } ${isHomePage ? styles.fixedHamburgerMenu : ''} ${
                purlAgentData
                    ? isAuthenticated
                        ? isHomePage
                            ? styles.purlBannerVisible
                            : styles.noHomeBannerVisible
                        : isHomePage
                        ? styles.purlBannerVisibleWithCloseIcon
                        : styles.noHomeBannerVisibleWithCloseIcon
                    : ''
            }`}
        >
            <ListItem
                className={styles.listitem}
                onClick={handleNavigation('/')}
                text="home"
            />
            {items.map(({ title, navigationLink }, index) => (
                <ListItem
                    text={title}
                    key={index}
                    isActived={activedLink.includes(
                        navigationLink?.split('/')[1]
                    )}
                    onClick={handleNavigation(navigationLink)}
                />
            ))}
            {!purlAgentData && <PhoneListItem />}

            {toBoolean(process.env.REACT_APP_SHOW_LOGIN_BTN) &&
                !isAuthenticated && (
                    <SignInButton
                        className={styles.signInButton}
                        onClick={() => handleLoginClick()}
                    />
                )}

            {toBoolean(process.env.REACT_APP_SHOW_LOGIN_BTN) &&
                isAuthenticated && (
                    <UserProfile
                        onLogout={handleLogout}
                        onItemClick={onItemClick}
                    />
                )}
        </ul>
    );
};

export default HamburgerMenu;
